
@if (eviQuote) {
  <div class="d-xl-block mb-40">
    <div class="notice notice--evi">
      <div class="notice__content">
        <img src="assets/icn/ai-new.svg" class="icon" />
        <p><strong>Already have a policy schedule?</strong><br>Upload it now and skip straight to your personalised quote
      </p>
    </div>
    <div class="notice__tray">
      <a href="javascript:;" class="button button--evi button--md" (click)="showEviWithUpload()" data-trigger="evi">Get started</a>
    </div>
  </div>
</div>
}
<!-- <label class="custom-input custom-input--radio custom-input--category-select {{item?.info_comment ? 'has-note' : ''}}" [ngClass]="item?.disable === '1' ? 'is-disabled' : null" *ngFor="let item of getGroup(1); let i = index;">
<input type="radio" name="category-select-example-1"
  [checked]="item.checked"
  [name]="uniqueControlName"
  [value]="item?.answer"
  (change)="checkSelect(item)"
  >
  <span class="custom-input__indi"></span>
  <span class="custom-input__label">
    <span class="custom-input__note" *ngIf="item?.info_comment">
      <svg class="icon">
        <use xlink:href="#info-small"></use>
      </svg>
      <span>{{item?.info_comment}}</span>
    </span>
    <span class="custom-input__label-wrap">
      <span class="custom-input__label-content">
        <span class="custom-input__label-title">
          <strong>{{item?.answer}}</strong>
          <span *ngIf="item?.bundle == 1" class="tag-pill tag-pill--promo tag-pill--promo-category">
            <img src="assets/icn/badge-personal.svg" class="icon">
            Bundle &amp; Save
          </span>
        </span>

        <span class="custom-input__label-description" [innerHTML]="item?.description"></span>
      </span>

      <span class="custom-input__label-icon">
        <img [src]="item?.mobile_img" class="icon icon--lg d-md-none">
        <svg-icon [src]="item?.image_url" class="icon d-none d-md-inline-block" [applyClass]="false"></svg-icon>
      </span>
    </span>

  </span>
</label> -->


@for (item of getGroup(1); track item; let i = $index) {
  <label class="tile">
    <input type="radio" name="category-select-example-1"
      [checked]="item.checked"
      [name]="uniqueControlName"
      [value]="item?.answer"
      [disabled]="readOnly || item?.disable === '1'"
      (change)="checkSelect(item)"
      >
      <div class="tile__inner">
        <div class="tile__main">
          <div class="tile__content">
            <div class="tile__indi"><span></span></div>
            <div class="tile__label">
              <div class="tile__title">{{item?.answer}}</div>
              <div class="tile__subtitle">{{item?.description}}</div>
            </div>
          </div>
          <div class="tile__right">
            <svg-icon [src]="item?.image_url" class="icon icon--tile" [applyClass]="true"></svg-icon>
          </div>
        </div>
      </div>
    </label>
  }

  <hr class="hr--xs">

  @for (item of getGroup(2); track item; let i = $index) {
    <div class="form-group mb-10">
      @if (item?.group_intro) {
        <div class="form-group__label" >{{item?.group_intro}}</div>
      }
      <!-- <label class="custom-input custom-input--radio custom-input--category-select" [ngClass]="item?.disable === '1' ? 'is-disabled' : null" >
      <input type="radio" name="category-select-example-1"
        [checked]="item.checked"
        [name]="uniqueControlName"
        [value]="item?.answer"
        (change)="checkSelect(item)"
        >
        <span class="custom-input__indi"></span>
        <span class="custom-input__label">
          <span class="custom-input__note" *ngIf="item?.info_comment">
            <svg class="icon">
              <use xlink:href="#info-small"></use>
            </svg>
            <span >{{item?.info_comment}}</span>
          </span>
          <span class="custom-input__label-wrap">
            <span class="custom-input__label-content">
              <span class="custom-input__label-title">
                <strong>{{item?.answer}}</strong>
                <span *ngIf="item?.bundle == 1" class="tag-pill tag-pill--promo tag-pill--promo-category">
                  <img src="assets/icn/badge-personal.svg" class="icon">
                  Bundle &amp; Save
                </span>
              </span>
              <span class="custom-input__label-description" [innerHTML]="item?.description"></span>
            </span>
            <span class="custom-input__label-icon">
              <img [src]="item?.mobile_img" class="icon icon--lg d-md-none">
              <svg-icon [src]="item?.image_url" class="icon d-none d-md-inline-block" [applyClass]="true"></svg-icon>
            </span>
          </span>
        </span>
      </label> -->
      <label class="tile">
        <input type="radio" name="category-select-example-1"
          [checked]="item.checked"
          [name]="uniqueControlName"
          [value]="item?.answer"
          [disabled]="readOnly || item?.disable === '1'"
          (change)="checkSelect(item)"
          >
          <div class="tile__inner">
            <div class="tile__main">
              <div class="tile__content">
                <div class="tile__indi"><span></span></div>
                <div class="tile__label">
                  <div class="tile__title">{{item?.answer}}</div>
                  <div class="tile__subtitle">{{item?.description}}</div>
                </div>
              </div>
              <div class="tile__right">
                <svg-icon [src]="item?.image_url" class="icon icon--tile" [applyClass]="true"></svg-icon>
              </div>
            </div>
          </div>
        </label>
      </div>
    }

